export const KPIKeys = {
  IMPRESSIONS: 'IMPRESSIONS',
  CLICKS: 'CLICKS',
  CTR: 'CTR',
  CONVERSIONS: 'CONVERSIONS',
  AVERAGE_CPC: 'AVERAGE_CPC',
  EXPENSES: 'EXPENSES',
};
export const KPIKeysBackendMapper = {
  [KPIKeys.IMPRESSIONS]: 'total_views',
  [KPIKeys.CLICKS]: 'total_clicks',
  [KPIKeys.CTR]: 'total_ctr',
  [KPIKeys.AVERAGE_CPC]: 'total_cpc',
  [KPIKeys.EXPENSES]: 'total_spent',
  [KPIKeys.CONVERSIONS]: 'total_conversions',
};

export const KPIText = {
  [KPIKeys.IMPRESSIONS]: 'Показы',
  [KPIKeys.CLICKS]: 'Клики',
  [KPIKeys.CTR]: 'CTR',
  [KPIKeys.AVERAGE_CPC]: 'Средняя цена клика',
  [KPIKeys.EXPENSES]: 'Расходы',
  [KPIKeys.CONVERSIONS]: 'Конверсии',
};

export const ShortKPIText = {
  [KPIKeys.AVERAGE_CPC]: 'Ср. цена клика',
};

export const GenitiveKPIText = {
  [KPIKeys.IMPRESSIONS]: 'Показов',
  [KPIKeys.CLICKS]: 'Кликов',
  [KPIKeys.CTR]: 'CTR',
  [KPIKeys.AVERAGE_CPC]: 'Средней цены клика',
  [KPIKeys.EXPENSES]: 'Расходов',
  [KPIKeys.CONVERSIONS]: 'Конверсий',
};

export const ExtendsKPIText = {
  [KPIKeys.IMPRESSIONS]: 'Общие показы',
  [KPIKeys.CLICKS]: 'Общие клики',
  [KPIKeys.CTR]: 'Общий CTR',
  [KPIKeys.AVERAGE_CPC]: 'Общая средняя цена клика',
  [KPIKeys.EXPENSES]: 'Общие расходы',
  [KPIKeys.CONVERSIONS]: 'Общие конверсии',
};

export const AnalyticsType = {
  OVERVIEW: 'OVERVIEW',
  ADVANCED: 'ADVANCED',
};

export const AnalyticsTypeText = {
  [AnalyticsType.OVERVIEW]: 'Обзор',
  [AnalyticsType.ADVANCED]: 'Аккаунты и кампании',
};
